var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"relative"},[_c('img',{staticClass:"w-max",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.bannerImg}}),_c('tabList',{attrs:{"tabList":_vm.tabList},on:{"changeTab":_vm.changeTab}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }